// Note: same zones as TIMEZONES in helpers/constants.js, which cannot be imported by Jest (import.meta)
export const PLACE_TIMEZONES = {
  AZ: 'US/Arizona',
  CT: 'America/Chicago',
  ET: 'America/New_York',
  MT: 'America/Denver',
  PT: 'America/Los_Angeles',
} as const

export const DEFAULT_PLACE_TIMEZONE = PLACE_TIMEZONES.CT
